// Module
var code = "<div class=\"component\" ng-class=\"{'empty': !$ctrl.component}\">\n  <div class=\"component-icon\" ng-if=\"$ctrl.component\"></div>\n  <div class=\"component-title\" ng-if=\"$ctrl.component\">\n    {{$ctrl.component.name}}\n  </div>\n  <div class=\"component-empty\" ng-if=\"!$ctrl.component\">\n    Input not connected\n  </div>\n</div>\n";
// Exports
module.exports = code;